exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".VehicleState{margin-bottom:45px}.VehicleState_fade-enter-active,.VehicleState_fade-leave-active{opacity:1;transform:translateY(0);transition:opacity .1s ease-in,transform .1s ease-in}.VehicleState_fade-enter,.VehicleState_fade-leave-to{opacity:0;transform:translateY(20px)}@media screen and (max-width:768px){.VehicleState{margin-bottom:10px}}.VehicleState--variantProductOverlay{margin-bottom:0}@media screen and (min-width:768px){.VehicleState--variantProductOverlay{padding-right:30px}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-09d60d34","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/resources/scripts/components/garage/VehicleState.vue
// module id = 1300
// module chunks = 0